import { Controller } from '@hotwired/stimulus'
import { post } from '../lib/request'

export default class extends Controller {
  static targets = ['label', 'select', 'in', 'cm']
  static values = {
    metric: { type: Boolean, default: false },
  }

  connect = () => {
    this.run()
  }

  inTargetConnected = (element) => {
    element.addEventListener('click', this.toggle)
  }

  cmTargetConnected = (element) => {
    element.addEventListener('click', this.toggle)
  }

  toggle = (event) => {
    event.preventDefault()
    if (event.target.style.color === 'white') return

    this.metricValue = !this.metricValue
    this.run()
    this.setMetricSession()
  }

  run = () => {
    this.setButtons()
    this.setLabel()
    this.convertOptions()
  }

  setButtons = () => {
    if (this.metricValue) {
      this.selectState(this.cmTarget)
      this.deselectState(this.inTarget)
    }
    else {
      this.selectState(this.inTarget)
      this.deselectState(this.cmTarget)
    }
  }

  deselectState = (element) => {
    element.style.color = '#4B5563'
    element.style.borderWidth = '1px'
    element.style.borderColor = '#6b7280'
    element.style.backgroundColor = 'white'
  }

  selectState = (element) => {
    element.style.color = 'white'
    element.style.borderWidth = '0'
    element.style.backgroundColor = '#6b7280'
  }

  setLabel = () => {
    if (this.metricValue) {
      this.labelTarget.innerHTML = '(centimeters)'
    }
    else {
      this.labelTarget.innerHTML = '(inches)'
    }
  }

  convertOptions = () => {
    [...this.selectTarget.options].forEach((option) => {
      if (this.metricValue) {
        const split = option.innerHTML.split('x')
        const converted = split.map(s => (parseFloat(s) * 2.54).toFixed(2))
        option.innerHTML = converted.join(' x ')
      }
      else {
        option.innerHTML = option.value
      }
    })
  }

  setMetricSession = () => {
    const params = { metric: this.metricValue }
    post('/options', { body: JSON.stringify(params), responseKind: 'turbo-stream' })
  }
}
